<template>
	<div>
		<v-dialog
				v-model="dialog"
				content-class="rounded-xl"
				persistent
				scrollable
				width="600px"
		>
			<template v-slot:activator="{ on, attrs }">
				<slot name="activatorr"></slot>
			</template>
			<v-form v-model="isValid">
				<v-card class="position-relative" rounded="xl">

					<v-card-title class="d-flex justify-space-between ma-0 ma-md-4">
						<div class="w-100">
							<div class="align-center d-flex justify-space-between">
								<h6 v-if="!!newMessage">
									New {{ title }}
								</h6>
								<h6 v-else>
									Replying to: {{ replyMsg.senderName }}
								</h6>
								<v-btn
										class="mt-n1 me-n2"
										color="black"
										depressed
										icon
										@click="dialog = false"
								>
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</div>
						</div>
					</v-card-title>

					<v-card-text class="text-body-2">

						<v-row v-if="!newMessage.lockSubject">
							<v-col>
								<ui-box background-color="#f5fafc" border-color="#b1d2df">
									<v-row noGutters @click="toggleShowRecipients">
										<v-col cols="auto">
											<v-icon class="me-2 mt-1">
												mdi-account-check-outline
											</v-icon>
										</v-col>
										<v-col>
											<h6>
												Selected Recipient List
												<v-badge
														class="ms-1"
														color="secondary"
														:content="userRecipients.length || 0"
														:value="userRecipients.length || 0"
												></v-badge>
											</h6>
										</v-col>
										<v-col cols="auto">
											<v-btn icon small>
												<v-icon v-if="showRecipients">mdi-chevron-up</v-icon>
												<v-icon v-else>mdi-chevron-down</v-icon>
											</v-btn>
										</v-col>
									</v-row>

									<ui-box
											v-if="showRecipients"
											background-color="rgba(255, 255, 255, 0.5)"
											border-color="#b1d2df"
											class="mx-n4 mb-n4 mt-4 requirements"
									>
										<v-simple-table>
											<template v-slot:default>
												<thead>
												<tr>
													<th class="text-left">Name</th>
													<th class="text-left">Email</th>
												</tr>
												</thead>
												<tbody>
												<tr
														v-for="recipient in userRecipients"
														:key="recipient.email"
												>
													<td class="font-weight-medium text-caption">
														{{ recipient.name }}
													</td>
													<td class="text-caption">{{ recipient.email }}</td>
												</tr>
												</tbody>
											</template>
										</v-simple-table>
									</ui-box>

								</ui-box>
							</v-col>
						</v-row>
						<v-divider class="my-8" v-if="!newMessage.lockSubject"></v-divider>
						<v-row v-if="users && !!newMessage">
							<v-col v-if="newMessage.lockSubject && userRecipients.length">
								<div class="grey--text text-caption">Send to:</div>
								<span class="text-body-1">{{ userRecipients[0].name }}</span>
							</v-col>
							<v-col v-else>
								<v-select
										v-model="userRecipients"
										class="rounded-lg"
										clear
										:disabled="newMessage.disableRecipients"
										:hide-details="newMessage.disableRecipients"
										hide-selected
										:items="newMessage.disableRecipients ? recipients : users"
										item-text="name"
										:label="newMessage.disableRecipients ? 'Recipient(s)' : 'Select Recipient(s)'"
										multiple
										outlined
										return-object
										:rules="rules.recipients"
								>
									<template v-slot:item="{ item }">
										<v-list-item-content>
											<v-list-item-title>
												{{ item.name }} - {{ item.email }}
											</v-list-item-title>
										</v-list-item-content>
									</template>
									<template v-slot:selection="data">
										<div class="text-truncate" style="max-width: 99%;">
											{{ userRecipients.map(user => user.name).join(', ') }}
										</div>
									</template>
								</v-select>
							</v-col>
						</v-row>
						<v-row>
							<v-col v-if="newMessage.lockSubject">
								<div class="grey--text text-caption">Subject:</div>
								<span class="text-body-1">{{ privateMessage.subject }}</span>
							</v-col>
							<v-col v-else>
								<v-text-field
										v-model="privateMessage.subject"
										class="rounded-lg required"
										label="Subject"
										outlined
										:rules="rules.subject"
								></v-text-field>
							</v-col>
						</v-row>
						<v-row>
							<v-col v-if="newMessage.lockSubject">
								<v-textarea
										outlined
										class="rounded-lg required"
										v-model="privateMessage.message"
										:extensions="extensions"
										:rules="[messageRule]"
										:label="privateMessage.messsageLabel"
										:rows="privateMessage.rows"
								></v-textarea>
							</v-col>
							<v-col v-else>
								<tiptap-vuetify
										ref="message"
										:card-props="{
										flat: true
									}"
										class="rounded-lg required"
										v-model="privateMessage.message"
										:extensions="extensions"
										:rules="[messageRule]"
								></tiptap-vuetify>
								<!-- Hidden for validation -->
								<v-input
										class="mb-n4"
										type="hidden"
										:rules="[messageRule]"
										v-model="message"
								>
								</v-input>
							</v-col>
						</v-row>
						<div class="form-group" v-if="!newMessage.hideAttachments">
							<label for="message-images">Add Image(s)</label>
							<div class="dropbox">
								<input
										id="message-images"
										type="file"
										ref="imageInput"
										name="attachments[]"
										multiple
										@change="imageUpload()"
										accept="image/*,application/pdf"
										class="input-file"
								>
								<p v-if="isSending">
								<span class="spinner-border spinner-border-sm text-primary"
											role="status"></span> Uploading files...
								</p>
								<p v-else>
									Drag your file(s) here to begin<br> or click to browse
								</p>
							</div>
							<p v-for="(f,i) in imageFiles" :key="`media-${i}`"
								 class="block-content mb-0 d-flex align-items-center justify-content-between image-file-remove">
								{{ f.name }}
								<button class="btn btn-sm btn-danger" type="button"
												@click="removeMedia(i)">
									Remove
								</button>
							</p>
						</div>

					</v-card-text>
					<v-card-actions>
						<v-btn
								v-if="newMessage && newMessage.canTest"
								class="me-2 me-md-4 rounded-lg"
								color="secondary"
								depressed
								:disabled="!isValid"
								:loading="isSending"
								outlined
								@click="testDialog = true"
						>
							Send Test
						</v-btn>
						<v-spacer></v-spacer>
						<div class="text-right border-top">
							<v-btn
									class="me-2 me-md-4 rounded-lg"
									color="grey darken-1"
									depressed
									:loading="isSending"
									outlined
									@click="dialog = false"
							>
								Cancel
							</v-btn>
							<v-btn
									class="rounded-lg"
									color="primary"
									depressed
									:disabled="showSendTest || isSending || !isValid"
									:loading="isSending"
									:prepend-icon="'mdi-paper-plane'"
									@click="sendMessage"
							>
								Send Message
							</v-btn>
						</div>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>

		<v-dialog
				v-model="testDialog"
				content-class="rounded-xl"
				persistent
				scrollable
				width="600px"
		>
			<template v-slot:activator="{ on, attrs }">
				<slot name="activatorr"></slot>
			</template>
			<v-form v-model="isTestValid">
				<v-card class="position-relative" rounded="xl">

					<v-card-title class="d-flex justify-space-between ma-0 ma-md-4">
						<div class="w-100">
							<div class="align-center d-flex justify-space-between">
								<h6>Send Test Message</h6>
								<v-btn
										class="mt-n1 me-n2"
										color="black"
										depressed
										icon
										@click="testDialog = false"
								>
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</div>
						</div>
					</v-card-title>

					<v-card-text class="text-body-2">
						<v-row>
							<v-col class="text-body-2">
								This test email will only send to the emails entered below. <strong>Hit
								ENTER after each.</strong>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-combobox
										v-model="privateMessage.testEmails"
										class="required rounded-lg"
										deletable-chips
										:delimiters="[',', ' ']"
										label="Email(s)"
										multiple
										outlined
										:rules="[testEmailRule]"
										small-chips
								>
									<template v-slot:selection="{ attrs, parent, item, index, selected }">
										<v-chip
												v-bind="attrs"
												:color="chipColors[index]"
												:dark="chipColors[index] === 'error'"
												:input-value="selected"
												small
										>
											<span class="pr-2">
												{{ item }}
											</span>
											<v-icon
													class="me-n1"
													small
													@click="parent.selectItem(item)"
											>
												$delete
											</v-icon>
										</v-chip>
									</template>
								</v-combobox>
							</v-col>
						</v-row>
					</v-card-text>

					<v-card-actions>
						<v-spacer></v-spacer>
						<div class="text-right border-top">
							<v-btn
									class="me-2 me-md-4 rounded-lg"
									color="grey darken-1"
									depressed
									:loading="isSending"
									outlined
									@click="testDialog = false"
							>
								Cancel
							</v-btn>
							<v-btn
									class="rounded-lg"
									color="primary"
									depressed
									:disabled="isSending || !isTestValid"
									:loading="isSending"
									:prepend-icon="'mdi-paper-plane'"
									@click="sendTestMessage"
							>
								Send Test
							</v-btn>
						</div>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>
	</div>
</template>

<script>
import {
	TiptapVuetify,
	Bold,
	Italic,
	Strike,
	Underline,
	BulletList,
	OrderedList,
	ListItem,
	HorizontalRule,
	History
} from 'tiptap-vuetify';

export default {
	name: 'CreateMessage',
	components: {
		TiptapVuetify
	},
	props: {
		// users is given for the array for them to select.
		users: {
			type: Array,
			default: () => ([])
		},
		replyMsg: {
			type: Object,
			default: () => {
			}
		},
		friendMessage: {
			type: Object,
			default: () => {
			}
		},
		newMessage: {
			type: [Boolean, Object],
			default: () => {
			}
		},
		//recipients is who this will go to.
		recipients: {
			type: Array,
			default: () => ([])
		},
		venueId: {
			type: Number,
			default: null
		}
	},
	data: () => {
		return {
			currentStatus: null,
			dialog: false,
			emailRegex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
			errors: [],
			extensions: [
				History,
				Underline,
				Strike,
				Italic,
				ListItem,
				BulletList,
				OrderedList,
				Bold,
				HorizontalRule
			],
			imageFiles: [],
			isInitial: true,
			isSending: false,
			isTestValid: false,
			isValid: false,
			partner_id: window.bwPartnerId,
			privateMessage: {
				message: '',
				rows: 2
			},
			rules: {
				recipients: [v => !!v || 'At least one recipient is required.'],
				subject: [v => !!v || 'Subject is required.']
			},
			showRecipients: false,
			showSendTest: false,
			testDialog: false,
			testEmail: '',
			title: "Message",
			uploadError: null
		}
	},
	watch: {
		newMessage: {
			deep: true,
			handler(o, n) {
				this.privateMessage = { ...this.privateMessage, ...this.newMessage };
			}
		}
	},
	computed: {
		chipColors() {
			return this.getChipColors();
		},
		message() {
			const div = document.createElement('div');
			div.innerHTML = this.privateMessage.message || '';
			return div.textContent || div.innerText || '';
		},
		userRecipients: {
			get() {
				return this.recipients
			},
			set(v) {
				this.$emit('recipient-update', v)
			}
		},
	},
	methods: {
		close() {
			this.dialog = false;
		},

		getChipColors() {
			return this.privateMessage.testEmails.map((email) => {
				return this.emailRegex.test(email) ? 'success' : 'error';
			});
		},

		imageUpload() {
			this.isSending = true
			this.imageFiles = [
				...this.imageFiles,
				...Object.values(this.$refs.imageInput.files)
			] //appending new files
			this.$refs.imageInput.value = null // were tracking internally. resetting this so we can re upload.
			if(this.imageFiles) {
				setTimeout(() => {
					this.isSending = false
				}, 3000);
			}
		},
		messageRule(v) {
			return !!v || (this.privateMessage.messsageLabel || 'Message') + ' is required.'
		},
		open() {
			this.dialog = open;
		},
		removeEmail(parent, item) {
			const index = parent.indexOf(item);
			parent.splice(index, 1);
		},
		removeMedia(i) {
			this.imageFiles.splice(i, 1)
			delete this.$refs.imageInput.files[i]
		},
		removeRecipient(id) {
			const index = this.userRecipients.findIndex(i => i.id === id);
			if(index >= 0) {
				this.userRecipients.splice(index, 1);
			}
		},
		reset() {
			this.uploadError = null;
			this.imageFiles = []
		},

		async sendMessage() {
			await this.sendPrivateMessage();
			window.EventBus.$emit('system-messages', [
				{
					message: 'Your message sent',
					messageType: 'success'
				}
			]);
			this.imageFiles = [];
			this.privateMessage.message = '';
			this.privateMessage.subject = '';
			this.$emit('resetMsg', true)
		},

		async sendTestMessage() {
			await this.sendPrivateMessage();
			window.EventBus.$emit('system-messages', [
				{
					message: 'Your  test  message sent',
					messageType: 'success'
				}
			]);

			delete this.privateMessage.testEmails;
			this.testDialog = false;
		},

		async sendPrivateMessage() {
			this.isSending = true;
			return new Promise(async (resolve, reject) => {

				this.privateMessage.message = (this.privateMessage.preMessage || '') + this.privateMessage.message;

				this.privateMessage.params = {};
				if(this.venueId)
					this.privateMessage.params.venueId = this.venueId;

				if(this.replyMsg && !_.isEmpty(this.replyMsg)) {
					if(this.replyMsg.sender_user_id)
						this.privateMessage.recipientUserIds = [this.replyMsg.sender_user_id];
					if(this.replyMsg.id)
						this.privateMessage.parent_id = this.replyMsg.id;
				}
				else if(this.recipients.length) {
					this.privateMessage.recipientUserIds = this.recipients.map(x => x.id);
				}
				if(this.newMessage?.blankTemplate)
					this.privateMessage.params.blankTemplate = this.newMessage.blankTemplate;

				await axios.post(`/privateMessages`, this.privateMessage).then((res) => {
					this.isSending = false;
					resolve(res);
				});
			});
		},

		testEmailRule(v) {
			if(!v.length) return 'At least one test email is required.';

			for (const email of v) {
				if(!this.emailRegex.test(email)) {
					return 'All email addresses must be valid.';
				}
			}

			return true;
		},

		toggleShowRecipients() {
			this.showRecipients = !this.showRecipients;
		},

		toggleshowSendTest() {
			this.showSendTest = !this.showSendTest;
		}
	},
	mounted() {
		this.reset();

		this.errors.recipientError = "This is an error - with recipients of course."

		if(this.newMessage?.subject) this.privateMessage.subject = this.newMessage.subject;
		if(this.newMessage?.message) this.privateMessage.message = this.newMessage.message;

		this.showRecipients = false;
		this.showSendTest = false;
	}
}
</script>

<style lang="scss" scoped>
@import 'tiptap-vuetify/dist/main.css';
@import '~vuetify/src/styles/settings/_variables'; // breakpoints

::v-deep .tiptap-vuetify-editor {
	& .v-card {
		border: solid 1px rgba(0, 0, 0, 0.38);
		border-radius: map-get($rounded, 'lg');

		& .tiptap-vuetify-editor__toolbar {
			& header {
				border-top-left-radius: map-get($rounded, 'lg');
				border-top-right-radius: map-get($rounded, 'lg');
			}
		}
	}
}
</style>

<style lang="scss">
.dropbox {
	outline: 2px dashed grey;
	outline-offset: -10px;
	background: lightsteelblue;
	color: dimgray;
	padding: 10px 10px;
	min-height: 200px;
	position: relative;
	cursor: pointer;
	border-radius: 4px;
}

.input-file {
	opacity: 0;
	width: 100%;
	height: 200px;
	position: absolute;
	cursor: pointer;
}

.dropbox:hover {
	background: rgb(161, 214, 231); /* when mouse over to the drop zone, change color */
}

.dropbox p {
	font-size: 1.2em;
	text-align: center;
	padding: 50px 0;
}

.list-unstyled {
	display: flex;
}

.img-thumbnail {
	max-height: 150px;
}

.error {
	color: red;
	font-weight: bold;
}

.image-file-remove {
	padding: 15px 0;
	transition: all .5s ease-in-out;
	margin-bottom: 0;

	&:first-child {
		margin-top: 10px;
	}

	&:hover {
		background-color: #f1f1f1;
	}
}

</style>
